import { render, staticRenderFns } from "./showColumn.vue?vue&type=template&id=2b2e94ec&scoped=true"
import script from "./showColumn.vue?vue&type=script&lang=js"
export * from "./showColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2e94ec",
  null
  
)

export default component.exports